import React from 'react';

const HealthCheck: React.FC = () => {
  return (
    <div>
      <h2>OK</h2>
      <p>Status: Healthy</p>
    </div>
  );
};

export default HealthCheck;